<div class="kt-portlet">
	<kt-portlet-header [sticky]="false" [title]="'Location Inventory'" [class]="'kt-portlet__head--lg'">

	</kt-portlet-header>
	<div class="kt-portlet__body" style="overflow: scroll;">
		<table class="table">
			<thead>
			  <tr>
				<th>Product</th>
				<!-- <th class="pl-5">Site Qty</th>
				<th class="pl-5">Drop Qty</th>
				<th class="pl-5">Tot. Qty</th> -->
				<th class="pl-5">Site Qty</th>
			  </tr>
			</thead>
			<tbody>
				<tr *ngFor="let item of inventory">
					<td class="pt-3">
						<span>{{getProductDisplayName(item.prodName)}}</span>
					</td>
					<!-- <td>
						<mat-form-field style="margin: -10px;" >
							<input matInput [(ngModel)]="item.siteBagCnt" class="text-center" min="0" max="100" type="number">
							<span matSuffix class="font-weight-bold">&nbsp; Bags</span>
						</mat-form-field>
					</td>
					<td>
						<mat-form-field style="margin: -10px;" >
							<input matInput [(ngModel)]="item.bagsDropCnt" class="text-center" min="0" max="100" type="number">
							<span matSuffix class="font-weight-bold">&nbsp; Bags</span>
						</mat-form-field>
					</td> -->
					<td>
						<mat-form-field style="margin: -10px;" >
							<input matInput [(ngModel)]="item.totalBagCnt" class="text-center" min="0" max="100" type="number">
							<span matSuffix class="font-weight-bold">&nbsp; Bags</span>
						</mat-form-field>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="row ml-auto">
			<button type="button" class="mr-3" (click)="submit()" color="primary" mat-raised-button>
				Submit
			</button>
		</div>

	</div>
</div>
